module.exports = __webpack_public_path__ + "img/960.7ecb926b.svg";